import {
  Component, Mixins, Watch, Vue, Prop,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type {
  ApplyChannelData,
  ApplyProductData,
} from '@/api/apply-product/types';

import {
  ChannelDisableEnum,
  RouteMarketEnum,
} from '@/api/apply-product/types';
import { Toast } from '@hb/coffee';
import '@/views_v2/home/store';

import LoadingSkeleton from '../loading-skeleton';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component
export default class NewSelectChannel extends Mixins() {
  @ApplyProductStore.State channel!: ApplyChannelData;

  @ApplyProductStore.State amount!: string;

  @ApplyProductStore.State channelList!: ApplyChannelData[];

  @ApplyProductStore.State product!: ApplyProductData;

  @ApplyProductStore.State is24NeedRightAndNormalIs36!: boolean;

  @Prop() private switchChannelOpenRemindPopup!: (channel: ApplyChannelData) => Promise<boolean>;

  // 渠道展开状态
  private isExpandChannel = false;

  // 渠道是否超过两行
  private exceedingHeight = false;

  /** 渠道 第二行是否不可用 */
  private channelSecondLineDisable = false;

  /** 渲染营销推荐内容 */
  private renderMarketingContent(item: ApplyChannelData) {
    if (item.marketingDesc) {
      return (
        <span class={style.marketingContent}>
          <i class={style.marketingIcon} />
          {item.marketingDesc}
        </span>
      );
    }
    return null;
  }

  private renderSingle() {
    return (
      <div class={[style.newSelectChannel, style.single]}>
        <div class={style.channelTitle}><span>放款机构</span></div>
        <div class={style.channelRight}>
          <div class={style.prdName}>
            {this.channelList.length && this.channelList[0].productName}
          </div>
          {this.channelNotes ? (
            <div class={style.singleBottomContent}>
              {/* 渠道配套提示 */}
              <span class={style.singleChannelTips}>
                {this.channelNotes}
              </span>
            </div>
          ) : ''}
        </div>
      </div>
    );
  }

  private renderMultiple() {
    const { productId } = this.channel || {};
    /** 可用资方列表,过滤掉 单行资方展示渠道 */
    const canAvailableList = (this.channelList || [])
      .filter((item) => !this.isNotAvailable(item) && !this.isFirstRowDisplay(item));
    /** 不可用资方列表 */
    const notAvailableList = (this.channelList || []).filter((item) => this.isNotAvailable(item));
    /** 单行展示资方 */
    const isFirstRowDisplayList = (this.channelList || [])
      .filter((item) => this.isFirstRowDisplay(item) && !this.isNotAvailable(item));

    return (
      <div class={[style.newSelectChannel, this.isExpandChannel && style.allChannelContent]}>
        <div class={style.multiTop}>
          <div class={style.channelTitle}><span>放款机构</span></div>
          {(this.channelNotes || this.exceedingHeight) ? (
            <div class={style.bottomContent}>
              {/* 渠道配套提示 不展开，但是有提示时 */}
              {!this.exceedingHeight && this.channelNotes
              && <span class={style.channelTips}>
                  {this.channelNotes}
                </span>
              }
              {/* 收起/展开显示区域 但是无提示时 */}
              {this.exceedingHeight && !this.channelNotes && <div
                class={style.expand}
                onClick={this.changeChannelHeight.bind(this, this.isExpandChannel ? '收起' : '展开')}
              >
                <span class={style.expendNotes}>{this.isExpandChannel ? '收起' : '展开'}</span>
              </div>}
              {/* 又需要展开，又有提示 */}
              {this.exceedingHeight && this.channelNotes && <div
                class={style.expand}
                onClick={this.changeChannelHeight.bind(this, this.channelNotes)}
              >
                <span class={style.expendNotes}>{this.channelNotes}</span>
              </div>}
            </div>
          ) : ''}
        </div>
        {/* 渠道展示区域 */}
        <div class={[style.channelContent, this.channelSecondLineDisable && style.channelSingleContent]} ref="channelBox_channelContent">
          {
            isFirstRowDisplayList.length > 0 && (
              <div class={style.channelAvailable} ref="channelBox_channelAvailable_firstRowDisplay">
                {isFirstRowDisplayList.map((items) => (
                    <span
                      onClick={this.changeChannel.bind(this, items, false)}
                      class={[
                        style.channelItem,
                        // 可用渠道
                        productId === items.productId && style.channelActive,
                      ]}
                      ref={productId === items.productId ? 'channelActive' : ''}
                    >
                      {this.renderMarketingContent(items)}
                      {items.productName}可借{Number(items.availableAmount)}元
                    </span>
                ))}
              </div>
            )
          }
          {
            canAvailableList.length > 0 && (
              <div class={style.channelAvailable} ref="channelBox_channelAvailable">
                {canAvailableList.map((items) => (
                    <span
                      onClick={this.changeChannel.bind(this, items, false)}
                      class={[
                        style.channelItem,
                        // 可用渠道
                        productId === items.productId && style.channelActive,
                      ]}
                      ref={productId === items.productId ? 'channelActive' : ''}
                    >
                      {this.renderMarketingContent(items)}
                      {items.productName}可借{Number(items.availableAmount)}元
                    </span>
                ))}
              </div>
            )
          }
          {
            notAvailableList.length > 0 && (
              <div class={style.channelDisable} ref="channelBox_channelDisable">
                {notAvailableList.map((items) => (
                    <span
                      onClick={this.changeChannel.bind(this, items, true)}
                      class={[
                        style.channelItem,
                        // 不可用渠道
                        style.unAvailableChannel,
                      ]}>{items.productName}可借{Number(items.availableAmount)}元</span>
                ))}
              </div>
            )
          }
          {
            (this.channelList || []).length === 0 && (
              <div class={style.loadingBox}>
                 <LoadingSkeleton class={style.loadingItem} height={27} />
                 <LoadingSkeleton class={style.loadingItem} height={27} />
              </div>
            )
          }
        </div>
      </div>
    );
  }

  private render() {
    if (this.channelList.length === 1) {
      return this.renderSingle();
    }
    return this.renderMultiple();
  }

  /** 判断当前渠道是否不可用 */
  private isNotAvailable(channel: ApplyChannelData): boolean {
    const { disabled } = channel || {};
    return disabled === ChannelDisableEnum.NOT_AVAILABLE;
  }

  /** 判断当前渠道 是否是需要在首位单行展示，服务端会控制，只返回一个 */
  private isFirstRowDisplay(channel: ApplyChannelData) : boolean {
    const { firstRowDisplay } = channel || {};
    return firstRowDisplay === true;
  }

  private get channelNotes() {
    const { routeMarket } = this.channel || {};
    const { notes } = (this.product && this.product.productInfo) || {};
    return routeMarket === RouteMarketEnum.SERIAL ? '最终放款机构以放款结果为准' : (notes || '');
  }

  /** 切换收起/展开 */
  private changeChannelHeight(buttonContent?: string) {
    this.isExpandChannel = !this.isExpandChannel;
    if (buttonContent) {
      this.$ubtPageButtonNew('finance_loan_apply_moreLender', {
        buttonContent,
      });
    }
  }

  /** 切换渠道 */
  private async changeChannel(channel: ApplyChannelData, unAvailable: boolean) {
    const { productId, disabled } = this.channel || {};
    // 选相同渠道不处理
    if (channel.productId === productId && channel.disabled === disabled) return;
    this.$ubtPageButton(
      '臻有钱_提现申请_选择提现渠道',
      'commodityId',
      channel && channel.productId,
      'status',
      `${channel && channel.disabledStatus}`,
    );
    if (unAvailable) {
      Toast(channel.alertMsg);
      return;
    }
    /** 若切换渠道时，有非疲劳度中 && 展示挽留弹窗，用户选择同意，则本次渠道切换不生效 */
    if (await this.switchChannelOpenRemindPopup(channel)) {
      return;
    }
    this.$emit('change', channel, unAvailable);
  }


  private moduleExpose() {
    if (this.exceedingHeight) {
      this.$ubtModuleExposeNew('finance_loan_apply_moreLender');
    }
  }

  @Watch('channelList', { immediate: true })
  private channelListChange(list: ApplyChannelData | undefined) {
    /**
     * https://hellobike.yuque.com/yxr77w/oyyz8n/xoasc89bbxfq3q1p
     * 1. 所有可用 只有一行 一行展示。
      2. 所有可用 刚好两行，两行展示
      3. 不可用和可用不在同一行，不可用换行展示
      4. 第二行不可用情况下， 只展示一行（可用），显示折叠按钮。
      5. 第三行不可用情况下，只展示两行（可用），显示折叠按钮
      6. 初始折叠状态 最多两行，超出两行 展示折叠按钮
      7. 特殊情况：自营推荐情况，自营独占一行，默认只展示一行，显示折叠按钮
     */
    const calcHeight = () => {
      /** 默认最大高度2行 */
      /** 整个容器 */
      const myBox = this.$refs.channelBox_channelContent as HTMLDivElement;

      /** 不可用渠道div容器 */
      const disableBox = this.$refs.channelBox_channelDisable as HTMLDivElement;
      /** 可用渠道div容器 */
      const availableBox = this.$refs.channelBox_channelAvailable as HTMLDivElement;

      /** 单行展示渠道 div容器 */
      const firstRowBox = this.$refs.channelBox_channelAvailable_firstRowDisplay as HTMLDivElement;

      /** 选中span元素 */
      const channelActive = this.$refs.channelActive as HTMLDivElement;


      if (!myBox) return;
      // 获取盒子的内容高度
      const contentHeight = myBox.scrollHeight;
      /** 盒子可见高度，max-length, 默认2倍item高度 */
      const visibleHeight = myBox.clientHeight;

      /** 可用渠道高度 */
      const availableHeight = availableBox && availableBox.scrollHeight;
      /** 不可用渠道高度 */
      const disableHeight = disableBox && disableBox.scrollHeight;
      /** 单行展示 盒子高度 */
      const firstRowBoxHeight = firstRowBox && firstRowBox.scrollHeight;

      /** 不可用渠道距离顶部高度 */
      const disableOffsetTop = disableBox && disableBox.offsetTop;

      /** 选中span元素 距离顶部高度 */
      const channelActiveOffsetTop = channelActive && channelActive.offsetTop;

      /** 盒子元素高度为0 退出 */
      if (!contentHeight) return;

      /** 首行展示有内容, 逻辑特殊处理 */
      if (firstRowBoxHeight) {
        /** 可用渠道 或者 无可用渠道 有内容 */
        if (availableHeight !== undefined || disableHeight !== undefined) {
          /** 展开按钮显示 */
          this.exceedingHeight = true;
          /** 变成单行 */
          this.channelSecondLineDisable = true;
        }
      } else {
        /** 全部可用||全部不可用 ，可用或者不可用盒子高度为null */
        if ((availableHeight === undefined && disableHeight !== undefined)
        || (availableHeight !== undefined && disableHeight === undefined)) {
          /** 内容高度大于盒子高度时，显示 展开按钮 */
          if (contentHeight > visibleHeight) {
            /** 展开按钮显示 */
            this.exceedingHeight = true;
          } else {
            /** 展开按钮隐藏 */
            this.exceedingHeight = false;
          }
        } else if (availableHeight !== undefined && disableHeight !== undefined) {
          /** 不可用和可用都存在 */
          if (disableOffsetTop && (
            /** 当距离顶部高度 等于 盒子高度，说明内容只有一行可视，当不可用距离顶部高度 大于 盒子高度，高度要变一行，否则不变
             * 当不可用距离顶部距离小于2层盒子高度，说明在第二行，需要隐藏不可用，盒子高度变层1行, 且显示展开按钮
             */
            disableOffsetTop === visibleHeight
              ? disableOffsetTop + 5 > visibleHeight : disableOffsetTop + 5 < visibleHeight
          )) {
          /** 变成单行 */
            this.channelSecondLineDisable = true;
            /** 展开按钮显示 */
            this.exceedingHeight = true;
          } else {
          /** 大于等于盒子高度，不可用在第三行，高度不变成1行，显示展开按钮 */
            this.channelSecondLineDisable = false;
            /** 展开按钮显示 */
            this.exceedingHeight = true;
          }
        }
      }

      /** 如果选中元素距离顶部高度 大于 可见内容高度，展开全部内容 */
      if (channelActiveOffsetTop > visibleHeight) {
        this.changeChannelHeight();
      }
    };

    if (list) {
      Vue.nextTick(() => {
        calcHeight();
        this.moduleExpose();
      });
    }
  }

  /** 24+单通道普通通道切换到轻资产场景，默认展开渠道列表 */
  @Watch('is24NeedRightAndNormalIs36', { immediate: true })
  private is24NeedRightAndNormalIs36Change(val: boolean) {
    if (val) {
      this.isExpandChannel = true;
    }
  }
}
